export enum PaymentMethod {
  canpay = 'canpay',
  cash = 'cash',
  /** @knipignore Knip has trouble detecting enum members not referred to explicitly. */
  credit = 'credit',
  /** @knipignore */
  debit = 'debit',
  moneris = 'moneris',
  /** @knipignore */
  payfirma = 'payfirma',
  /** @knipignore */
  paytender = 'paytender',
  square = 'square',
  stronghold = 'stronghold',
}

/** As payment methods come and go, we still need access to old methods in components that represent old orders (like receipts) */
export enum HistoricalPaymentMethod {
  aeropay = 'aeropay',
  aeropayWhiteLabel = 'aeropay_white_label',
  canpay = 'canpay',
  cash = 'cash',
  credit = 'credit',
  debit = 'debit',
  moneris = 'moneris',
  payfirma = 'payfirma',
  paytender = 'paytender',
  square = 'square',
  stronghold = 'stronghold',
}
